export default __webpack_public_path__ + "static/media/Hashh.3b8b09ac.png";